import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup';


export default function DiscordIFC() {
    return (
        <div>
            <div className='c_c'>
                <iframe className='Tr_block_img' src="https://discord.com/widget?id=906267280986472499&theme=dark" width="1500" height="600" allowtransparency="true" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>
            </div>

            <div className='All_block_one'>
                <p className='All_text_block_one'>Играй, веселись и общаемся с нами на сервере WorldGames! Мы ждём тебя! <br />
                    450 Количество переходов по ссылке discord.gg за месяц <br />
                    225 Количество просмотров страницы сервера за месяц <br />
                    25  Макс. количество людей в войсе <br />
                    204 Участника
                </p>
            </div>
            <div className='Tr_stick'></div>
            <div className='Dysplay_none'>

                <div className='DiscordIFC_color'>

                    <h3><i className="bi bi-person-lines-fill">  </i>Администрация</h3>
                    <ListGroup>
                        <ListGroup.Item action variant="danger">
                            Имеет все возможности что [Игрок, Семейство пупсиков]
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/kick</b> ~ Кикает участника. Первым параметром указывается участник, вторым — причина кика
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/ban</b> ~ Банит участника. Первым параметром указывается участник, вторым — причина бана
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/mute</b> ~ Мутит участника. Первым параметром указывается участник, вторым — причина мута
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/warn</b> ~ Выдаёт предупреждение участнику. Первым параметром указывается участник, вторым — нарушение
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/user-info</b> ~ Выдаёт информацию об участнике. Единственным параметром указывается участник
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/infractions</b> ~ Показывает количество нарушений участника. Единственным параметром указывается участник
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/tempban</b> ~ Банит участника на определённый срок. Первым параметром указывается участник, вторым — срок, третьим — причина бана
                        </ListGroup.Item>
                        <ListGroup.Item action variant="danger">
                            <b>/role-info</b> ~ Выдаёт информацию о роли. Единственным параметром указывается роль
                        </ListGroup.Item>
                        <br />

                        <h3><i className="bi bi-reddit">  </i>Семейство пупсиков</h3>
                        <ListGroup.Item action variant="info">
                            Имеет все возможности что [Игрок]
                        </ListGroup.Item>
                        <ListGroup.Item action variant="info">
                            Красивый бирюзовый ник или можете сменить цвет ника во вкладке -цвет-ника
                        </ListGroup.Item>
                        <ListGroup.Item action variant="info">
                            Приоритетный режим в голосовом чате
                        </ListGroup.Item>
                        <ListGroup.Item action variant="info">
                            Использовать внешние стикеры
                        </ListGroup.Item>
                        <ListGroup.Item action variant="info">
                            Использовать внешние эмодзи
                        </ListGroup.Item>
                        <ListGroup.Item action variant="info">
                            Частные голосовые каналы
                        </ListGroup.Item>

                        <br />

                        <h3><i className="bi bi-robot">  </i>Игрок</h3>
                        <ListGroup.Item action variant="success">
                            <b>/</b> ~ Посмотреть список всех доступных команд
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/like</b> ~ Лайкнуть сервера
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/info</b> ~ Информация о сервере
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/help</b> ~ Информация о командах
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/poll create</b> ~ Создайте опрос
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/poll results</b> ~ Просмотр результатов опроса и рейтингов
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/coins</b> ~ Посмотреть ваш баланс
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/daily</b> ~ Дать денег игроку
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/play</b> ~ Включить музыку
                        </ListGroup.Item>
                        <ListGroup.Item action variant="success">
                            <b>/stop</b> ~ Остановить музыку
                        </ListGroup.Item>
                    </ListGroup>
                </div>
            </div >
        </div >
    )
}
